import { useMemo } from 'react'

import { formFieldsValues } from '@types'

type TUseReplaceFieldsInFilterProps = {
  allFieldsValues?: formFieldsValues
  objectFilters?: Record<string, string[]>
}

type TValuesTargetFields = (string | number | boolean | null | undefined)[]

export const useReplaceFieldsInFilter = ({
  allFieldsValues,
  objectFilters,
}: TUseReplaceFieldsInFilterProps) => {
  const updatedFilter = useMemo(() => {
    if (!objectFilters || Object.keys(objectFilters).length === 0 || !allFieldsValues) return ''

    const rawFilter = Object.keys(objectFilters)[0]
    const namesTargetFields = Object.values(objectFilters)[0] as string[]

    const valuesTargetFields: TValuesTargetFields = namesTargetFields.map(nameField => {
      return allFieldsValues[nameField]
    })

    if (valuesTargetFields.includes(undefined)) return ''

    let updatedFilter = rawFilter

    valuesTargetFields.forEach(fieldValue => {
      const findIndex = updatedFilter.indexOf('%s')

      if (findIndex === -1) return

      updatedFilter = updatedFilter.replace(
        '%s',
        typeof fieldValue === 'string' && fieldValue.includes(' ')
          ? `"${fieldValue}"`
          : String(fieldValue)
      )
    })

    return updatedFilter
  }, [objectFilters, allFieldsValues])

  return { updatedFilter }
}
